import { useAtomValue } from "@effect/atom-react";
import {
  createEnvironmentPresentationAtoms,
  type EnvironmentPresentation,
} from "@afar-research/client-runtime/state/presentation";
import type { EnvironmentId } from "@afar-research/contracts";
import { Atom } from "effect/unstable/reactivity";

import { hostEnvironment } from "../connection/hostEnvironment";
import { serverEnvironment } from "./server";

export const environmentPresentations = createEnvironmentPresentationAtoms({
  environmentEntriesValueAtom: hostEnvironment.environmentEntriesValueAtom,
  stateAtom: hostEnvironment.stateAtom,
  serverConfigValueAtom: serverEnvironment.configValueAtom,
});

const EMPTY_ENVIRONMENT_PRESENTATION_ATOM = Atom.make<EnvironmentPresentation | null>(null).pipe(
  Atom.withLabel("web-environment-presentation:empty"),
);

export function useEnvironmentPresentation(environmentId: EnvironmentId | null) {
  const catalog = useAtomValue(hostEnvironment.environmentEntriesValueAtom);
  const presentation = useAtomValue(
    environmentId === null
      ? EMPTY_ENVIRONMENT_PRESENTATION_ATOM
      : environmentPresentations.presentationAtom(environmentId),
  );
  return {
    isReady: catalog.isReady,
    presentation,
  };
}
